// input from component (fail because of form submit)
import { useNavigate } from "react-router-dom";
import React from "react";
import { useState } from "react";
import axios from "axios";

const Start_Main_Register_Form = (props) => {
    const [firstName,setFirstName] = useState("");
    const [lastName,setLastName] = useState("");
    const [userName,setUserName] = useState("");
    const [email,setEmail] = useState("");
    const [password,setPassword] = useState("");
    const [message,setMessage] = useState("");
    const [classTitle,setClassTitle] = useState("");

    let navigate = useNavigate();

    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            const response = await axios.post("/register",{
                firstName,lastName,userName,email,password
            },{
                withCredentials:true,
                headers:{
                    "Content-Type":"application/json"
                }
            });
            setClassTitle("start_main_form_message_success");
            setMessage(response.data.msg);
            setTimeout(() => {
                navigate("/start/signin");
            },2000);
        } catch (error) {
            setClassTitle("start_main_form_message_fail");
            setMessage(error.response.data.msg);
        }
    }
    return(
        <form className="start_main_signup_form" onSubmit={handleSubmit}>
            <input className="start_main_signup_form_input_fname start_main_signup_form_input" type="text" name="fname" id="signup_fname" placeholder="First name" required onChange={(e) => setFirstName(e.target.value)} /><br/>
            <input className="start_main_signup_form_input_lname start_main_signup_form_input" type="text" name="lname" id="signup_lname" placeholder="Last name" onChange={(e) => setLastName(e.target.value)} /><br/>
            <input className="start_main_signup_form_input_username start_main_signup_form_input" type="text" name="username" id="signup_username" placeholder="User name" required onChange={(e) => setUserName(e.target.value)} /><br/>
            <input className="start_main_signup_form_input_email start_main_signup_form_input" type="email" name="email" id="signup_email" placeholder="Email" required onChange={(e) => setEmail(e.target.value)} /><br/>
            <input className="start_main_signup_form_input_password start_main_signup_form_input" type="password" name="password" id="signup_password" placeholder="Password" required onChange={(e) => setPassword(e.target.value)} /><br/>
            <input className="start_main_form_input_button start_main_start_button" type="submit" name="submit" id="signup_submit" value="Let's go" />
            <div className={`start_main_form_message ${classTitle}`}>{message}</div>
        </form>
    )
}

export default Start_Main_Register_Form;